import { zodForgivingSchema } from '../../zod/forgivingSchema';
import z from 'zod';

export type SystemConfigType = z.infer<typeof SystemConfigType>;
export type SystemConfigEntry = z.infer<typeof SystemConfigEntry>;

export const SystemConfigType = z.enum(['dynamic', 'deployment']);

export const SystemConfigEntry = z.object({
    configGuid: z.string(),
    tenant: z.string().nullish(),
    storeGuid: z.string().nullish(),
    cartGuid: z.string().nullish(),
    type: SystemConfigType.nullish(),
    key: z.string().nullish(),
    value: z.string().nullish(),
    target: z.int().nullish(),
    level: z.int().nullish(),
    v: z.int().nullish(),
    createdOn: z.coerce.date().nullish(),
    modifiedOn: z.coerce.date().nullish(),
    deletedOn: z.coerce.date().nullish(),
});

export const GetAllConfigsRequest = z.object({
    configGuids: z.string().array().nullish(),
    tenants: z.string().nullable().array().nullish(),
    storeGuids: z.string().nullable().array().nullish(),
    cartGuids: z.string().array().nullish(),
    keys: z.string().array().nullish(),
    skip: z.int().nullish(),
    limit: z.int().nullish(),
});
export type GetAllConfigsRequest = z.infer<typeof GetAllConfigsRequest>;

export const GetAllConfigsResponse = zodForgivingSchema(
    z.object({
        skip: z.int(),
        limit: z.int(),
        totalItemCount: z.int(),
        items: SystemConfigEntry.array(),
    }),
);
export type GetAllConfigsResponse = z.infer<typeof GetAllConfigsResponse>;

export const SetConfigDto = SystemConfigEntry.pick({
    tenant: true,
    storeGuid: true,
    cartGuid: true,
    key: true,
    value: true,
});
export type SetConfigDto = z.infer<typeof SetConfigDto>;
